import { useRouter } from "next/router";
import { ProductTypeReadMoreBox } from "styles/jss/ProductsPage.styles";
import { PrimaryButton } from "../../../styles/jss/Layout.styles";
import Link from "next/link";
import { useTranslation } from "next-i18next";

const ProductTypeRead = ({ description }) => {
  const { t } = useTranslation(["products"]);
  const { query } = useRouter();
  return (
    <ProductTypeReadMoreBox>
      <h2 className="title">{query.type.toUpperCase()}</h2>
      <p className="content">{description}</p>
      <Link
        href={`products/${
          query?.type?.toLowerCase() === "hdpe"
            ? "high-density-polyethylene"
            : query?.type?.toLowerCase() === "mdpe"
            ? "medium-density-polyethylene"
            : query?.type?.toLowerCase() === "ldpe"
            ? "low-density-polyethylene"
            : query?.type?.toLowerCase() === "olefin" && "olefin"
        }`}
      >
        <a>
          <PrimaryButton>{t("readMore")}</PrimaryButton>
        </a>
      </Link>
    </ProductTypeReadMoreBox>
  );
};

export default ProductTypeRead;
